import React from 'react';
import { useParams } from 'react-router-dom';
import PageTitle from '../components/pagetitle';
import data from '../assets/fake-data/data-blog';

function BlogDetails() {
    const { id } = useParams();
    const blogPost = data.find(post => post.id === parseInt(id));

    return (
        <div className='inner-page'>
            <PageTitle title='Detalle del Blog' />

            <section className="tf-section tf-blog pt-16">
                <div className="overlay" style={{ background: 'rgb(14 3 39 / 50%)' }} />

                <div className="container mx-auto">
                    <div className="row">
                        <div className="post-details w-full">
                            <h4 className="title text-2xl font-bold mb-4">{blogPost.heading}</h4>
                            <p className="date flex items-center text-gray-500">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
                                    <g opacity="0.5">
                                        <path d="M4.5 2V3.5M11.5 2V3.5M2 12.5V5C2 4.60218 2.15804 4.22064 2.43934 3.93934C2.72064 3.65804 3.10218 3.5 3.5 3.5H12.5C12.8978 3.5 13.2794 3.65804 13.5607 3.93934C13.842 4.22064 14 4.60218 14 5V12.5M2 12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5M2 12.5V7.5C2 7.10218 2.15804 6.72064 2.43934 6.43934C2.72064 6.15804 3.10218 6 3.5 6H12.5C12.8978 6 13.2794 6.15804 13.5607 6.43934C13.842 6.72064 14 7.10218 14 7.5V12.5" stroke="#798DA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                </svg>
                                {blogPost.date}
                            </p>
                            <p className="authors mb-4 flex items-center text-gray-500">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
                                    <g opacity="0.5">
                                        <path d="M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8ZM8 9C5.79086 9 4 10.7909 4 13V14H12V13C12 10.7909 10.2091 9 8 9Z" fill="#798DA3" />
                                    </g>
                                </svg>
                                {blogPost.authors.join(', ')}
                            </p>
                            <div className="spacing mb-8"></div>
                            <div className="content-inner">
                                <div className="content-post">
                                    {blogPost.content.map((item, index) => {
                                        switch (item.type) {
                                            case 'title':
                                                return <h2 key={index} className="text-xl font-semibold mb-4">{item.value}</h2>;
                                            case 'subtitle':
                                                return <p key={index} className="sub-title text-lg font-medium mb-4">{item.value}</p>;
                                            case 'paragraph':
                                                return <p key={index} className="mb-4">{item.value}</p>;
                                            case 'image':
                                                return (
                                                    <div key={index} className="row mb-4 d-flex justify-content-center">
                                                        <img src={item.value} alt="Blog content" className="max-w-xs w-auto" />
                                                    </div>
                                                );
                                            case 'video':
                                                return (
                                                    <div key={index} className="row mb-4 d-flex justify-content-center">
                                                        <div className="aspect-w-16 aspect-h-9 w-full max-w-xs d-flex justify-content-center">
                                                            <iframe src={item.value} title="Video content" frameBorder="0" allowFullScreen className="w-full h-full"></iframe>
                                                        </div>
                                                    </div>
                                                );
                                            default:
                                                return null;
                                        }
                                    })}
                                </div>
                                <div className="spacing mb-8"></div>
                                <ul className="tag mb30">
                                    <li>Tags:</li>
                                    {blogPost.tags && blogPost.tags.map((tag, index) => (
                                        <li key={index}><span>{tag}</span></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default BlogDetails;